"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.parseJSON = exports.parseISO = exports.parse = exports.isValidISO = exports.fromUnixTime = void 0;
var _dateFns = require("date-fns");
/**
 * Checks if the given string is a valid ISO string and can be converted to a Date object.
 * @param value The string to check
 * @returns true if the string is a valid ISO string, false otherwise
 */
const isValidISO = (value, options) => {
  return (0, _dateFns.isValid)((0, _dateFns.parseISO)(value, options));
};
exports.isValidISO = isValidISO;
const parseISO = (argument, options) => {
  let parsedDate;
  try {
    parsedDate = (0, _dateFns.parseISO)(argument, options);
  } catch (e) {
    console.error(e);
    return new Date(0, 0);
  }
  if ((0, _dateFns.isValid)(parsedDate)) {
    return parsedDate;
  }
  console.error('Could not parse ISO string into date');
  return new Date(0, 0);
};
exports.parseISO = parseISO;
const parse = (dateString, formatString, referenceDate, options) => {
  let parsedDate;
  try {
    parsedDate = (0, _dateFns.parse)(dateString, formatString, referenceDate, options);
  } catch (e) {
    console.error(e);
    return new Date(0, 0);
  }
  if ((0, _dateFns.isValid)(parsedDate)) {
    return parsedDate;
  }
  console.error('Could not parse given string and format into date');
  return new Date(0, 0);
};
exports.parse = parse;
const parseJSON = argument => {
  let parsedDate;
  try {
    parsedDate = (0, _dateFns.parseJSON)(argument);
  } catch (e) {
    console.error(e);
    return new Date(0, 0);
  }
  if ((0, _dateFns.isValid)(parsedDate)) {
    return parsedDate;
  }
  console.error('Could not parse given string into date');
  return new Date(0, 0);
};
exports.parseJSON = parseJSON;
const fromUnixTime = unixTime => {
  let parsedDate;
  try {
    parsedDate = (0, _dateFns.fromUnixTime)(unixTime);
  } catch (e) {
    console.error(e);
    return new Date(0, 0);
  }
  if ((0, _dateFns.isValid)(parsedDate)) {
    return parsedDate;
  }
  console.error('Could not parse given Unix timestamp into date');
  return new Date(0, 0);
};
exports.fromUnixTime = fromUnixTime;